import { Outlet } from 'react-router';
import Footer from './components/Footer/Footer';
import './index.css';

export default function Layout() {
  return (
    <>
      <div className="page__content">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
